import styled from 'styled-components';

export const BuilderBox = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  background: #fafafa;
`;

export const GroupTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #8c8c8c;
  text-transform: uppercase;
  margin: 4px 0 8px;
`;
